import React, { useEffect, useState, forwardRef, useRef, useImperativeHandle } from "react";
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../RestaurantWidget/utilities/helper/helper";
import { getStorePaymentDetails, passPaymentMethodToDropin } from "../../../RestaurantWidget/utilities/api/paymentService";
import { useSelector, useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { placeCardOrder } from "../../../RestaurantWidget/utilities/api/restaurantsService";
import { setOrderEmpty, setSelectedOrderType } from "../../../../../../../redux/resturantWidgetSlice";
import { useHistory } from 'react-router';
import globalValues from "../../../../../utilities/apiRequests/globalValues";
import moment from "moment";


const HospitalityPaymentV4 = forwardRef((props, ref) => {
    const cardRef = useRef(null);
    const selectedPaymentMethodRef = useRef(null)
    const dispatch = useDispatch()
    let history = useHistory();
    const storeOrderLocalData = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)) : null
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const [paymentMethods, setPaymentMethods] = useState(null)
    // const customerDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS)) : {}
    const orderID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : ""
    const restaurantDataState = useSelector((state) => state.resturantData);


    useEffect(() => {
        if (storeOrderLocalData && orderID !== "") {
            let ref = uuidv4();
            const requestBody = {
                clientAPIRequestRef: ref,
                cloudLocationID: storeOrderLocalData.cloudLocationID,
                store: `Ecommerce_${storeOrderLocalData.cloudLocationID}`
            }
            getStorePaymentDetails(requestBody, companyDetails.PaymentIntegration.IntegrationData.Client_Key).then((response) => {
                if (response) {
                    setPaymentMethods(response)
                }
            })
        }

    }, [])
    const makeInstantPayment = async (data, customer) => {
        return new Promise((resolve) => {
            if (customer) {

                const total = restaurantDataState.orderDetails.Payment.
                    PaymentDetail.OrderTotal.Gross.AmountE5 ?? 0
                const uniqueID = uuidv4()
                const { paymentMethod } = data
                const cloudLodID = companyDetails.PaymentIntegration.IntegrationData?.Payment_CloudLocationID ? companyDetails.PaymentIntegration.IntegrationData?.Payment_CloudLocationID : storeOrderLocalData.cloudLocationID

                const paymentRequestBody = {
                    amount: {
                        currency: "GBP",
                        value: total
                    },
                    cloudLocationID: cloudLodID,
                    reference: `Online-${storeOrderLocalData.cloudLocationID}-Ecom-${uniqueID}`,
                    siteTransactionRef: orderID,
                    returnUrl: window.location.href,
                    store: `Ecommerce_${storeOrderLocalData.cloudLocationID}`,
                    countryCode: "GB",
                    shopperEmail: customer?.Email,
                    ShopperName: `${customer?.Name?.FirstName} ${customer?.Name?.LastName}`,
                    telephoneNumber: `+44${customer?.Contact?.Number}`,
                    paymentMethod,
                    isTokenized: false,
                    APISource: "Web",
                    shopperReference: localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_LOGGED_USER_ID) : localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                    additionalData: {
                        "allow3DS2": "true"
                    },
                }
                passPaymentMethodToDropin(paymentRequestBody, companyDetails.PaymentIntegration.IntegrationData.Client_Key).then((response) => {
                    resolve(response)
                }).catch(error => {
                    console.log("drop in  failed")
                    history.push(`/order/failed`)
                });
            } else {
                console.log("customer not available")
                history.push(`/order/failed`)
            }
        })

    }

    const handleTransaction = (stage) => {
        if (stage === "Authorised" || stage === "Received" || stage === "AuthenticationNotRequired") {
            const oid = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID)
            history.push(`/order/success/${oid}`)
            dispatch(setOrderEmpty())
            dispatch(setSelectedOrderType(""))
            localStorage.removeItem("selected_table")
            localStorage.removeItem("schedule_order")
            sessionStorage.removeItem("store_instruction")
        }
        else if (stage === "ChallengeShopper" || stage === "PresentToShopper" || stage === "AuthenticationNotRequired" || stage === "RedirectShopper" || stage === "IdentifyShopper") {


        } else {
            history.push(`/order/failed`)
        }
    }
    useEffect(() => {
        const initCheckout = async () => {

            const configuration = {
                paymentMethodsResponse: paymentMethods, // The `/paymentMethods` response from the server.
                clientKey: globalValues.payment.REACT_APP_PAYMENT_CLIENT_KEY, // Web Drop-in versions before 3.10.1 use originKey instead of clientKey.
                locale: "en-US",
                environment: globalValues.payment.REACT_APP_PAYMENT_CLIENT_ENVIRONMENT,
                analytics: {
                    enabled: true // 
                },
                onSubmit: async (state, dropin) => {
                    selectedPaymentMethodRef.current = state.data.paymentMethod.type
                    props.setSelectedPaymentMethod(state.data.paymentMethod.type)

                    const error = await props.onValidateBeforePayment()
                    if (error) return

                    if (state.data.storePaymentMethod === true) return

                    props.setIsOrderLoading(true)
                    props.setIsPaymentLoading(true)
                    if (state.data.paymentMethod.type === "applepay") {
                        await props.hanldeOrderUpdate()
                    }

                    if (restaurantDataState.orderCartData.Items.length === 0) return

                    const schedTime = JSON.parse(props.scheduleOrder)
                    const table = localStorage.getItem("selected_table")
                        ? JSON.parse(localStorage.getItem("selected_table")) : {}
                    const customer = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS)
                        ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CUSTOMER_DETAILS)) : {}

                    if (!customer) {
                        console.log("customerData not available")
                        history.push(`/order/failed`)
                        return
                    }
                    if (schedTime?.StartTime) {
                        const startTime = schedTime.StartTime.replace('Z', '')
                        const hasPassed = moment().isAfter(moment(startTime))
                        if (hasPassed) {
                            props.setIsOrderLoading(false)
                            props.setIsPaymentLoading(false)
                            props.setIsScheduleTimeError(true)
                            return
                        }
                    }

                    let customerData = [{ ...restaurantDataState.orderDetails.Customers[0], ...customer }]
                    let data = {
                        ...restaurantDataState.orderDetails,
                        PaymentType: "CARD",
                        Customers: customerData,
                        FulfillmentType: restaurantDataState.orderDetails.FulfillmentType,
                        DineIn: table ? table : props.selectedTable ? props.selectedTable : {},
                        OrderType: "MENU",
                        StoreInstructions: sessionStorage.getItem("store_instruction"),
                        ScheduledOrderTargetDeliveryTimeRange: schedTime.StartTime
                            ? { StartTime: schedTime.StartTime, EndTime: schedTime.EndTime } : {}
                    }

                    placeCardOrder(data).then((res) => {
                        if (res) {
                            makeInstantPayment(state.data, customer)
                                .then((response) => {
                                    if (response.action) {
                                        dropin.handleAction(response.action)
                                    } else {
                                        handleTransaction(response.resultCode)
                                    }
                                }).catch((e) => {
                                    console.log("instant order failed", e)
                                    props.setIsOrderLoading(false)
                                    props.setIsPaymentLoading(false)
                                    history.push(`/order/failed`)
                                })
                        } else {
                            console.log("payment order failed")
                            props.setIsOrderLoading(false)
                            props.setIsPaymentLoading(false)
                            history.push(`/order/failed`)
                        }
                    }).catch((error) => {
                        console.log("order failed", error)
                        history.push(`/order/failed`)
                    })
                },
                onAdditionalDetails: (state, dropin) => {
                    passPaymentMethodToDropin(
                        { ...state.data, orderID },
                        companyDetails.PaymentIntegration.IntegrationData.Client_Key
                    ).then((response) => {
                        if (response.action) {
                            dropin.handleAction(response.action)
                        } else {
                            handleTransaction(response.resultCode)
                        }
                    }).catch(() => {
                        history.push(`/order/failed`)
                    })
                },

                onError: (error) => {
                    console.error("Adyen error:", error)
                    props.setIsOrderLoading(false)
                    props.setIsPaymentLoading(false)
                    history.push(`/order/failed`)
                },
                onChange: (state) => {
                    if (state.data?.paymentMethod?.type) {
                        selectedPaymentMethodRef.current = state.data.paymentMethod.type
                        props.setSelectedPaymentMethod(state.data.paymentMethod.type)
                    }
                },
                paymentMethodsConfiguration: {
                    card: {
                        hasHolderName: true,
                        holderNameRequired: true,
                        enableStoreDetails: true,
                        hideCVC: false,
                        showPayButton: false
                    },
                    googlepay: {
                        environment: globalValues.payment.REACT_APP_PAYMENT_CLIENT_ENVIRONMENT === "live" ? "PRODUCTION" : "TEST",
                        amount: {
                            currency: "GBP",
                            value: restaurantDataState.orderDetails.Payment.PaymentDetail.OrderTotal.Gross.AmountE5 ?? 0
                        },
                        countryCode: "GB",
                        showPayButton: false,
                        buttonType: "buy",     // or "plain", "checkout", "donate", "order", "subscribe"
                        buttonSizeMode: "fill",
                        onAuthorized: (paymentData) => {
                            return Promise.resolve(paymentData)
                        },
                        configuration: {
                            gatewayMerchantId: companyDetails.PaymentIntegration.IntegrationData.MerchantName,
                            merchantName: companyDetails?.ShopperName ?? "Your Restaurant",
                            merchantId: globalValues.payment.REACT_APP_PAYMENT_CLIENT_ENVIRONMENT === "live"
                                ? globalValues.payment.REACT_APP_GOOGLEPAY_MERCHANT_ID
                                : "TEST"
                        },
                        allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                        allowedCardNetworks: ["AMEX", "DISCOVER", "MASTERCARD", "VISA"],
                    },
                    applepay: {
                        amount: {
                            currency: "GBP",
                            value: restaurantDataState.orderDetails.Payment.PaymentDetail.OrderTotal.Gross.AmountE5 ?? 0
                        },
                        countryCode: "GB",
                        showPayButton: true,
                        buttonType: "buy",
                        buttonColor: "black",
                        onAuthorized: (resolve, reject, event) => {
                            console.log("Apple Pay authorized:", event)
                            resolve(event)
                        },

                        onError: (error) => {
                            console.error("Adyen error:", error)
                            props.setIsOrderLoading(false)
                            props.setIsPaymentLoading(false)

                            if (error.name === "CANCEL") return

                            history.push(`/order/failed`)
                        },

                        onCancel: () => {
                            console.log("Apple Pay cancelled")
                            props.setIsOrderLoading(false)
                            props.setIsPaymentLoading(false)
                        }
                    },
                },
            };

            const checkout = await AdyenCheckout(configuration);
            const card = checkout
                .create('dropin', {
                    openFirstPaymentMethod: false,
                    onSelect: (activeComponent) => {
                        selectedPaymentMethodRef.current = activeComponent.type
                        props.setSelectedPaymentMethod(activeComponent.type)
                    }
                })
            card.mount('#card-container');
            cardRef.current = card;

        }
        if (paymentMethods)
            initCheckout()
    }, [paymentMethods])
    useImperativeHandle(ref, () => ({
        submit: () => {
            const card = cardRef.current;
            const type = selectedPaymentMethodRef.current
                ?? card?.activePaymentMethod?.type

            if (type === "googlepay") {
                card.activePaymentMethod?.submit()

            }
            //  else if (type === "applepay") {
            //     // Try submit first, fall back to button click
            //     if (card.activePaymentMethod?.submit) {
            //         card.activePaymentMethod.submit()
            //     } else {
            //         const applePayButton = document.querySelector('.adyen-checkout__applepay__button')
            //         applePayButton?.click()
            //     }

            // } 
            else if (type === "scheme") {
                if (card && card.isValid) {
                    card.submit();
                    props.setShowPaymentErrorModal(false)
                } else {
                    card.showValidation();
                    props.setIsOrderLoading(false)
                    props.setIsPaymentLoading(false)
                }
            } else {
                card?.showValidation?.()
            }
        },
        // Expose separate method for Google Pay specifically
        submitGooglePay: () => {
            const card = cardRef.current;
            card.activePaymentMethod?.submit()
        },
        getSelectedPaymentMethod: () => selectedPaymentMethodRef.current
    }));
    return <div id="card-container"></div>
})
export default HospitalityPaymentV4